import { linkOptions, Outlet } from "@tanstack/react-router";
import { DashboardHeader } from "./header";

export const programLinkOptions = (program?: string) => linkOptions({
  to: '/dashboard/$program',
  activeOptions: { exact: true },
  params: { program: program || 'weight-loss' }
})

export function ProgramLayout() {

  return (
    <main
      role="main"
      aria-label="Dashboard overview"
      className="min-h-screen w-full mx-auto"
    >
      <DashboardHeader
      />
      <Outlet />
    </main>
  )
}

